export default __webpack_public_path__ + "static/media/fire-hydrant.18202f7f.svg";